var React = require('react');

function Phone (props) {
    return React.createElement("svg",props,[React.createElement("style",{"type":"text/css","key":0},"\n\t.st0{fill-rule:evenodd;clip-rule:evenodd;}\n"),React.createElement("g",{"key":1},React.createElement("path",{"d":"M20.7,29.3c-4.8-4.8-9.4-10.4-7.2-12.6c5.5-5.5,5.9-5.1,0.3-12.1c-5.6-7-5.4-5.7-12.4,1.4c-3.7,4-0.2,16.7,12.8,29.7\n\t\tc13,13,26.1,16.4,29.7,12.8c7.5-7.4,8.1-7,1.4-12.4c-7-5.6-6.6-5.2-12.1,0.3C31.1,38.8,25.5,34.2,20.7,29.3z"}))]);
}

Phone.defaultProps = {"version":"1.1","id":"Warstwa_1","x":"0px","y":"0px","viewBox":"0 0 50 50","style":{"enableBackground":"new 0 0 50 50"},"xmlSpace":"preserve"};

module.exports = Phone;

Phone.default = Phone;
